import {HttpResponse, post} from '@/services/infrastructure/api.service'

const KRAVIA_API = '/api/kravia'

const initiateOnboarding = async (contactEmail: string) => {
    try {
        return await post(KRAVIA_API + '/onboarding/init', {contactEmail})
    } catch (e) {
        return false
    }
}

const updateCreditor = async (creditorId?: string) => {
    try {
        if(creditorId){
            return await post(KRAVIA_API + `/creditor/${creditorId}/settings`, {})
        } else return false
    } catch (e) {
        return false
    }
}

const postEmailInvitation = async (email: string) => {
    try {
        const response = await post(KRAVIA_API + '/invite', {email: email, isAccountant: false})
        return response as KraviaResponse
    } catch (e: any) {
        return e.response as HttpResponse
    }
}

export type KraviaResponse = {
    value: any
    successful: boolean
    errors: KraviaError[]
}

type KraviaError = {
    code: string
    args: string
}


const isKraviaResponse = (response: any): response is KraviaResponse => {
    return 'successful' in response
        && 'errors' in response
        && 'value' in response
}

export {initiateOnboarding, updateCreditor, postEmailInvitation, isKraviaResponse}